import * as Yup from 'yup';

export const altShipMethodsSchema = Yup.object().shape({
  address: Yup.string()
    .min(2, 'Too Short!')
    .max(255, 'Too Long!')
    .required('Required'),
});
